// removed by extract-text-webpack-plugin
module.exports = {"root":"Tab__root___3hgLM","isSelected":"Tab__isSelected___2q7jP","isDisabled":"Tab__isDisabled___1xYz0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseTabs/Tab/Tab.css
// module id = 969
// module chunks = 0